import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { JsmFeaturesEnabledData } from './JsmFeaturesEnabledData.types.tsx';
import { JsmFeaturesEnabledResourceType } from './JsmFeaturesEnabledResourceType.constants.tsx';

const ONE_HOUR_MS: number = 60 * 60 * 1000;

export const jsmFeaturesEnabledResource: RouteResource<JsmFeaturesEnabledData> =
	createResource<JsmFeaturesEnabledData>({
		type: JsmFeaturesEnabledResourceType,
		// Cross-project / site-wide — projectKey not required
		getKey: () => 'jsm-features-enabled',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-jsm-features-enabled" */
				'./getJsmFeaturesEnabled.tsx'
			),
		maxAge: ONE_HOUR_MS,
	});
